<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('preInvoice.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('preInvoice.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="d-flex">
            <ts-button outline color="info" @click="$router.push({ name: 'pre-invoice-create' })">{{ $t('add_new')
            }}</ts-button>
            <div class="ml-2 ts-rounded ts-border ts-px-2 ts-whitespace-no-wrap">
              <div class="ts-inline-block" style="margin-top: 0.4rem !important">
                <ts-button outline color="info" class="btn-xs" v-tooltip="$t('preInvoice.generate')" @click="generate">
                  <i class="fas fa-cogs"></i>
                </ts-button>
              </div>
              <div class="ts-inline-block ts-ml-2">
                <ts-button outline color="info" class="btn-xs" v-tooltip="$t('preInvoice.printByClass')"
                  @click.prevent="pdfByGrade">
                  <i class="fas fa-print"></i>
                </ts-button>
              </div>
            </div>
            <a-range-picker style="width: 280px; margin-left: 6px;" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              :defaultValue="rangeDate" @change="dateRangeChange">
              <template slot="renderExtraFooter"></template>
            </a-range-picker>
          </div>
          <div class="d-flex">
            <ts-input v-model="search" :placeholder="$t('search')" style="width: 250px" />
            <ts-button outline class="ml-2" v-tooltip="$t('invoice.filter')" @click.prevent="visible = true">
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-loading-banner :loading="exporting">
          <Table row-key="index" :columns="columns" :data="groupResources" :span-method="handleSpan" size="small"
            :loading="loading" highlight-row stripe>
            <template slot-scope="{ row }" slot="card_number">
              {{ row.student ? row.student.card_number : '' }}
            </template>
            <template slot-scope="{ row }" slot="full_name_en">
              {{ row.student ? row.student.full_name_en : '' }}
            </template>
            <template slot-scope="{ row }" slot="ac_term">
              {{ row.academic_term ? row.academic_term.term_name : '' }}
            </template>
            <template slot-scope="{ row }" slot="status">
              <span v-if="!row.is_paid" class="label label-danger">Unpaid</span>
              <span v-else class="label label-success">Paid</span>
            </template>
            <template slot-scope="{ row }" slot="is_deleted">
              <span v-if="row.is_deleted == 0" class="label label-success">Active</span>
              <span v-else class="label label-danger">Voided</span>
            </template>

            <template slot-scope="{ row }" slot="action">
              <a href="#" v-tooltip="$t('tooltip.show')" class="mr-2 text-primary" @click.prevent="show(row)">
                <i class="fas fa-eye"></i>
              </a>
              <a href="#" title="Edit" class="mr-2 text-primary" @click.prevent="edit(row)" v-if="!row.is_paid">
                <i class="fas fa-edit"></i>
              </a>
              <a href="#" v-tooltip="$t('pdf')" class="text-danger" @click.prevent="pdfView(row)"
                :disabled="row._deleting">
                <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
                <i class="fas fa-file-pdf" v-else></i>
              </a>
              <a href="#" @click.prevent="deleteRecord(row)" :disabled="row._deleting" v-if="!row.is_paid">
                <i class="fas fa-circle-notch spin ml-2" v-if="row._deleting"></i>
                <i class="fa fa-trash ml-2 text-red" v-else></i>
              </a>
            </template>
          </Table>
        </ts-loading-banner>
        <div class="d-flex justify-content-between align-items-center p-15">
          <ts-total-list v-model="pagination" />
          <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
        </div>
        <generate v-model="show_generate" @cancel="value => (show_generate = value)" @fetch="fetchData" />
        <!-- drawer -->
        <a-drawer :title="$t('invoice.filter')" placement="right" :closable="false" :visible="visible"
          @close="() => (visible = false)" :zIndex="1020" width="300px">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select style="width: 257px" v-model="branch_id" :options="branchs" showSearch mode="multiple"
                  :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                    " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                </a-select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label>{{ $t('preInvoice.paymentStatus') }}</label>
                <a-select style="width: 257px" v-model="model.status_id" :options="statuses" showSearch mode="multiple"
                  :filterOption="(input, option) =>
                    option.componentOptions.children[0].text
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                    " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                </a-select>
              </div>
            </div>
            <div class="col-md-12">
              <label>{{ $t('preInvoice.status') }}</label>
              <div>
                <a-radio-group v-model="model.is_deleted">
                  <a-radio :value="0" style="font-size: 13px">Active</a-radio>
                  <a-radio :value="1" style="font-size: 13px">Voided</a-radio>
                </a-radio-group>

              </div>
            </div>
          </div>
        </a-drawer>
      </div>
    </ts-card>
  </div>
</template>
<script>
import iTable from '@/store/i-table-helper'
import { Errors } from 'form-backend-validation'
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import FilterDate from './component/filter-date'
import Generate from './component/generate'
import PdfByGrade from './component/pdf-by-grade'
import PreviewPDF from './component/preview-pdf'
import Reason from './component/reason_delete'

export default {
  name: 'preInvoice',
  components: {
    Generate
  },
  data() {
    return {
      branchs: [],
      loading: false,
      visible: false,
      show_generate: false,
      exporting: false,
      errors: new Errors(),
      model: {
        status_id: undefined,
        is_deleted: 0,

      },
      statuses: [
        {
          value: 1,
          label: 'Paid'
        },
        {
          value: 0,
          label: 'Unpaid'
        }
      ],
      deleteModel: {
        void_reason: null
      }
    }
  },
  created() {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('preInvoice', [
      'resources',
      'pagination',
      'date_from',
      'date_to'
    ]),
    groupResources() {
      return iTable.rowGroup(this.resources, 'student.branch.branch_name_en')
    },
    search: {
      get() {
        return this.$store.state.preInvoice.search
      },
      set(newValue) {
        this.$store.commit('preInvoice/SET_SEARCH', newValue)
        this.$store.commit('preInvoice/RESET_CURRENT_PAGE')
      }
    },
    is_external() {
      return this.$store.state.authUser.is_external
    },
    branch_id: {
      get() {
        return this.$store.state.preInvoice.branch_id
      },
      set(newValue) {
        this.$store.commit('preInvoice/SET_BRANCH_ID', newValue)
      }
    },
    columns() {
      return [
        {
          key: 'column_name',
          tree: true,
          maxWidth: 15,
          className: 'text-primary bold'
        },
        {
          title: this.$t('preInvoice.preInvoiceDate'),
          key: 'pre_invoice_date',
          minWidth: 140
        },
        {
          title: this.$t('preInvoice.preInvoiceNumber'),
          key: 'pre_invoice_number',
          minWidth: 200
        },
        {
          title: this.$t('preInvoice.cardNumber'),
          slot: 'card_number',
          minWidth: 140
        },
        {
          title: this.$t('preInvoice.studentName'),
          slot: 'full_name_en',
          minWidth: 140
        },
        {
          title: this.$t('preInvoice.academicTermName'),
          slot: 'ac_term',
          minWidth: 150
        },
        {
          title: this.$t('preInvoice.totalAmount'),
          key: 'total_amount',
          minWidth: 120,
          align: 'center'
        },
        {
          title: this.$t('preInvoice.amountPaid'),
          align: 'center',
          minWidth: 120,
          key: 'amount_paid'
        },
        {
          title: this.$t('preInvoice.amountDue'),
          key: 'amount_due',
          minWidth: 120,
          align: 'center'
        },
        {
          title: this.$t('preInvoice.status'),
          slot: 'status',
          minWidth: 120,
          align: 'center'
        },
        {
          title: this.$t('preInvoice.paymentStatus'),
          minWidth: 150,
          slot:'is_deleted',
          align: 'center'
        },
        {
          title: this.$t('preInvoice.remark'),
          key: 'pre_invoice_remark',
          minWidth: 200
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    },
    rangeDate() {
      return [this.date_from, this.date_to]
    }
  },
  methods: {
    ...mapActions('preInvoice', ['destroy']),
    fetchData(attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'preInvoice/fetch',
          Object.assign(
            {},
            { branch_id: this.branch_id },
            attributes,
            this.model
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'preInvoice/SET_DATE_FROM',
        dateRange[0]
      )
      this.$store.commit(
        'preInvoice/SET_DATE_TO',
        dateRange[1]
      )
      this.fetchData()
    },
    getBranch() {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    show(record) {
      this.$store.commit('preInvoice/SET_SHOW_DATA', record)
      this.$router.push({
        name: 'pre-invoice-show',
        params: { id: record.inv_id }
      })
    },
    edit(record) {
      this.$store.commit('preInvoice/SET_SHOW_DATA', record)
      this.$router.push({
        name: 'pre-invoice-edit',
        params: { id: record.inv_id }
      })
    },
    pdfView(record) {
      this.$modal.show(
        PreviewPDF,
        {
          url: null,
          inv_id: record.inv_id
        },
        {
          height: 'auto',
          width: '60%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    filterDate() {
      this.$modal.show(
        FilterDate,
        {},
        {
          height: 'auto',
          width: '20%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        },
        {
          'before-close': this.fetchData
        }
      )
    },
    pdfByGrade() {
      this.$modal.show(
        PdfByGrade,
        {},
        {
          height: 'auto',
          width: '50%',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },
    generate() {
      this.show_generate = true
    },
    deleteRecord(record) {
      this.deleteModel.void_reason = null
      this.$confirm({
        title: this.$t('are_you_sure_to_delete'),
        content: h =>
          h(Reason, {
            props: {
              value: this.deleteModel,
              validate: this.errors,
              placeholder: this.$t('invoice.leaveReason')
            }
          }),
        okText: this.$t('yes'),
        okType: 'danger',
        cancelText: this.$t('no'),
        onOk: () => {
          return this.destroy({
            id: record.inv_id,
            data: this.deleteModel
          })
            .then(response => {
              this.$toasted.success(response.message)
              this.fetchData()
              return Promise.resolve(response)
            })
            .catch(error => {
              this.$toasted.error(error.message)
              this.errors = new Errors(error.errors)
              return Promise.reject(error)
            })
        },
        onCancel() { }
      })
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      return iTable.handleSpan(row, columnIndex, this.columns)
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({
        search,
        branch_id: this.branch_id,
        status_id: this.model.status_id,
        is_deleted: this.model.is_deleted
      })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value, status_id: this.model.status_id })
    }, 500),
    'model.status_id': debounce(function (value) {
      this.fetchData({ status_id: value, branch_id: this.branch_id })
    }, 500),
    is_external: debounce(function () {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
    'model.is_deleted': debounce(function (value) {
      this.fetchData({ is_deleted: value, branch_id: this.branch_id })
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('preInvoice/RESET_STATE')
    next()
  }
}
</script>
<style lang="css">
.bold {
  font-weight: bold;
}
</style>
